import { GET_HOTEL_ENQUIRY_DETAILS, GET_HOTEL_DETAILS, INSERT_HOTEL_ENQUIRY_ACCOMMODATION_LOG } from "../../../../../utils/constants";


const initialState = [];

function hotelEnquiryReducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_HOTEL_ENQUIRY_DETAILS:
      return [...state, payload];
    case GET_HOTEL_DETAILS:
      return [...state, payload];
    case INSERT_HOTEL_ENQUIRY_ACCOMMODATION_LOG:
      return [...state, payload];
    default:
      return state;
  }
};

export default hotelEnquiryReducer;